import { useAppSelector } from "integrations/redux/hooks"
import { selectActivatedFireId } from "features/map/control/selectors"
import {
    DownloadButtonData,
    NestedDownloadData,
} from "@nova/component-export-download-buttons-hover"
import { selectSelectedLayerIds } from "panels/content/side-panel/slice.new"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectRasterById } from "features/entity-caching/pdf-rasters/selectors"
import { selectLocalRasterById } from "./PDFRasterSlice"
import { Licenses } from "@nova/constants"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { pdfRasterPath } from "@nova/util-s3"

export const usePDFRasterDownloadButtonData = (): DownloadButtonData => {
    const workspaceId = useAppSelector(selectActiveWorkspaceId())
    const projectId = useAppSelector(selectActivatedFireId) as string
    const selectedLayerId = useAppSelector(selectSelectedLayerIds).at(-1)
    const id = selectedLayerId || ""
    const localPdfRaster = useAppSelector(selectLocalRasterById(id))
    const pdfRaster = useAppSelector(selectRasterById(id))

    const downloadButtonData: NestedDownloadData = {}

    if (!pdfRaster) return { exportOptions: downloadButtonData }

    const createFileName = (fileName: string) => {
        const parts = fileName.split(".")
        parts.splice(-2, 1)
        return parts.join(".")
    }

    const downloadPDF = async () => {
        let url = localPdfRaster?.pdfBlobUrl
        let shouldRevoke = false

        if (!url) {
            const s3Key = pdfRasterPath(workspaceId!, projectId, pdfRaster.filename)
            const buffer = await (await fileManagementApi.fetchFile(s3Key)).arrayBuffer()
            const blob = new Blob([buffer], { type: "application/pdf" })
            url = URL.createObjectURL(blob)
            shouldRevoke = true
        }

        const a = document.createElement("a")
        a.href = url
        a.download = createFileName(pdfRaster.filename)
        a.click()

        if (shouldRevoke) URL.revokeObjectURL(url)
    }

    downloadButtonData.PDF = { callback: downloadPDF, restrictedLicenses: [Licenses.Lite] }

    return { exportOptions: downloadButtonData }
}
